/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `water_level` - Water Level
 * * `flow_velocity` - Flow Velocity
 * * `discharge` - Discharge
 * * `volume` - Volume
 * * `pump_discharge` - Pump Discharge
 * * `wet_cross_section` - Wet Cross Section
 * * `lateral_discharge` - Lateral Discharge
 * * `wet_surface` - Wet Surface
 * * `rain` - Rain
 * * `simple_infiltration` - Simple Infiltration
 * * `leakage` - Leakage
 * * `interception` - Interception
 * * `surface_source_sink_discharge` - Surface Source Sink Discharge
 * @export
 */
export const FlowVariableEnum = {
  WATER_LEVEL: "water_level",
  FLOW_VELOCITY: "flow_velocity",
  DISCHARGE: "discharge",
  VOLUME: "volume",
  PUMP_DISCHARGE: "pump_discharge",
  WET_CROSS_SECTION: "wet_cross_section",
  LATERAL_DISCHARGE: "lateral_discharge",
  WET_SURFACE: "wet_surface",
  RAIN: "rain",
  SIMPLE_INFILTRATION: "simple_infiltration",
  LEAKAGE: "leakage",
  INTERCEPTION: "interception",
  SURFACE_SOURCE_SINK_DISCHARGE: "surface_source_sink_discharge",
} as const;
export type FlowVariableEnum = (typeof FlowVariableEnum)[keyof typeof FlowVariableEnum];

export function instanceOfFlowVariableEnum(value: any): boolean {
  for (const key in FlowVariableEnum) {
    if (Object.prototype.hasOwnProperty.call(FlowVariableEnum, key)) {
      if (FlowVariableEnum[key as keyof typeof FlowVariableEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FlowVariableEnumFromJSON(json: any): FlowVariableEnum {
  return FlowVariableEnumFromJSONTyped(json, false);
}

export function FlowVariableEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlowVariableEnum {
  return json as FlowVariableEnum;
}

export function FlowVariableEnumToJSON(value?: FlowVariableEnum | null): any {
  return value as any;
}

export function FlowVariableEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): FlowVariableEnum {
  return value as FlowVariableEnum;
}
